import { TreePine, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import vpixelLogo from "@/assets/vpixel-logo-small.webp";

const Footer = () => (
  <footer className="bg-forest-dark text-primary-foreground">
    <div className="container py-12">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        <div>
          <Link to="/" className="flex items-center gap-2 mb-4">
            <TreePine className="h-6 w-6 text-amber" />
            <span className="font-display text-lg font-bold">
              Chimay<span className="text-amber">Bois</span>
            </span>
          </Link>
          <p className="text-sm text-primary-foreground/70 leading-relaxed">
            La marketplace locale de bois de chauffage dans la région de Chimay.
            Achetez et vendez en toute confiance.
          </p>
        </div>
        <div>
          <h3 className="font-display font-semibold mb-4 text-base">Navigation</h3>
          <nav className="flex flex-col gap-2 text-sm text-primary-foreground/70">
            <Link to="/annonces" className="hover:text-amber transition-colors">Parcourir les annonces</Link>
            <Link to="/vendre" className="hover:text-amber transition-colors">Vendre mon bois</Link>
            <Link to="/" className="hover:text-amber transition-colors">Comment ça marche</Link>
          </nav>
        </div>
        <div>
          <h3 className="font-display font-semibold mb-4 text-base">Contact</h3>
          <div className="text-sm text-primary-foreground/70 space-y-2">
            <p>Région de Chimay, Belgique</p>
            <a href="mailto:info@chimaybois.be" className="flex items-center gap-1.5 hover:text-amber transition-colors">
              <Mail className="h-4 w-4" /> info@chimaybois.be
            </a>
            <p className="text-primary-foreground/65 text-xs mt-2">Une question, un problème ou une suggestion ? N'hésitez pas à nous écrire.</p>
          </div>
        </div>
      </div>
      <div className="border-t border-primary-foreground/10 mt-8 pt-6 text-center text-xs text-primary-foreground/65 space-y-1">
        <p>© 2026 ChimayBois.be — Tous droits réservés</p>
        <p className="flex items-center justify-center gap-1.5">
          Créé par
          <a href="https://www.vpixel.be" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 hover:text-amber transition-colors font-semibold">
            <img src={vpixelLogo} alt="" className="h-4 w-4" />
            V.Pixel
          </a>
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
